import { Controller } from '@hotwired/stimulus';

export default class DateFilledController extends Controller {
  connect() {
    this.update();
  }

  markFilled() {
    this.element.classList.add('is-filled');
  }

  update() {
    this.element.classList.toggle('is-filled', this.element.value !== '');
  }
}
